import { DataContainerService } from "../../../../infrastructure/datacontainer.service";
import { TransportData } from "../../../../infrastructure/transportdata";
import { DashboardsFetchRequest } from "./dashboardfetchrequest";

export class Dashboards {
    public static readonly EmbedCollectionName: string = "dashboard";

    FetchRequest: DashboardsFetchRequest = null as any;
    Rows: any[] = [];
    FromDate: string = '';
    ToDate: string = '';
    ChapterRef: number  = 0 ;

    // public static FromTransportData(td: TransportData) {
    //     let result: Dashboards = null as any;

    //     let dcs = DataContainerService.GetInstance();

    //     if (dcs.CollectionExists(td.MainData, Dashboards.EmbedCollectionName)) {
    //         let coll = dcs.GetCollection(td.MainData, Dashboards.EmbedCollectionName)!;
    //         for (let data of coll.Entries) {
    //             result = data as Dashboards;
    //         }
    //     }
    //     else {
    //         result = new Dashboards();
    //     }

    //     return result;
    // }


    public static FromTransportData(td: TransportData) {
        let result: any[] = [];

        let dcs = DataContainerService.GetInstance();

        if (dcs.CollectionExists(td.MainData, Dashboards.EmbedCollectionName)) {
            let coll = dcs.GetCollection(td.MainData, Dashboards.EmbedCollectionName)!;
            for (let data of coll.Entries) {
                result.push(data);
            }
        }
        else {
            result;
        }
        return result;
    }
}